import React from "react";
// @material-ui
import { makeStyles } from "@material-ui/core/styles";
// react-router-dom
import { Link } from "react-router-dom";
// styles
import styles from "./PostCardStyle";
// util
import { conversionDate, getTargetStr } from "../../util/util";

const useStyles = makeStyles(styles);

export default function PostCard(props) {
  const classes = useStyles();
  const { title, imgURL, articleURL, postDate, siteURL } = props;
  return (
    <div className={classes.postCardContainer}>
      <Link to={getTargetStr(articleURL, siteURL)} className={classes.link}>
        <img src={imgURL} alt="postImage" className={classes.postImg} />
        <div>
          <div className={classes.postCardTitle}>{title}</div>
          <div className={classes.postCardDate}>{conversionDate(postDate)}</div>
        </div>
      </Link>
    </div>
  );
}
